/*! @azure/msal-common v16.5.0 2026-04-16 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.5.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
